import { Button, Icon, Input, Modal } from "semantic-ui-react";

export default function BookingResultsPopup(props: any): JSX.Element {
  const { popup, setPopup, setBookingFilter } = props

  return (
    <Modal
      size="large"
      onClose={() => setPopup({ ...popup, edit: false })}
      open={popup.bookings}
    >
      <Modal.Header className="text-left">
        <div>
          <span>Bookings in 7 days</span>
        </div>
      </Modal.Header>
      <Modal.Content className="text-left">
        <div>
          {props.children}
        </div>
      </Modal.Content>
      <Modal.Actions >
        <Button color='black' onClick={() => {
          setBookingFilter({
            bookingNumber: null,
            email: null,
            fullName: null,
          })
          setPopup({
            ...popup,
            bookings: false,
            searchBooking: false
          })
        }}>
          Close
        </Button>
        <Button
          content="Back to Search"
          icon='left chevron'
          onClick={() => setPopup({ ...popup, bookings: false })}
          color="yellow"
        />
      </Modal.Actions>
    </Modal>
  )
}
